import { useState, useEffect } from "react"
import { IoCloseSharp } from "react-icons/io5";
import Cim from "../../../Cim"
import Kereses from "../../../components/Kereses";
import { arFuggveny } from "../../../utils/formazas";

const RendelesTermekek= ({ rendeles_id, onClose }) => {
    const [adatok, setAdatok] = useState({})
    const [keresettAdatok, setKeresettAdatok] = useState([])
    const [tolt, setTolt] = useState(true)
    const [hiba, setHiba] = useState(false)
    const [ures, setUres] = useState(false)

    useEffect(() => {
        const leToltes = async () => {
            try {
                const response = await fetch(Cim.Cim + "/rendelesTermekek/" + rendeles_id)
                const data = await response.json()

                if (response.ok) {
                    setAdatok(data)
                    setKeresettAdatok(data)
                    setTolt(false)
                } else if (response.status === 404) {
                    setUres(true)
                    setTolt(false)
                } else {
                    setHiba(true)
                    setTolt(false)
                }
            } catch (error) {
                console.log(error)
                setHiba(true)
            }
        }
        leToltes()
    }, [rendeles_id])

    const osszArSzamitas = () => {
        let osszeg = 0
        for (let elem of adatok) {
            osszeg += elem.rendeles_ar * elem.rendeles_darab
        }
        return osszeg
    }

    if (tolt)
        return <div className="text-center">Adatok betöltése folyamatban...</div>
    if (ures)
        return <div className="text-center">Ehhez a rendeléshez nem tartozik termék!</div>
    if (hiba)
        return <div className="text-center">Hiba történt az adatok betöltése közben.</div>

    return (
        <div className="container-fluid">
            <div className="row mb-3">
                <div className="col-12 text-center">
                    <h4>Rendelt termékek</h4>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12 text-center">
                    <Kereses adatok={adatok} keresettMezok={["termek_nev"]} setKeresettAdatok={setKeresettAdatok} />
                </div>
            </div>

            <div className="row justify-content-center mb-3">
                <div className="col-4 text-center fw-bold">Termék név</div>
                <div className="col-3 text-center fw-bold">Darab</div>
                <div className="col-5 text-center fw-bold">Rendelési ár</div>
            </div>

            {keresettAdatok.map((elem, index) => (
                <div className="row justify-content-center mb-3" key={index}>
                    <div className="col-4 text-center">{elem.termek_nev}</div>
                    <div className="col-3 text-center">{elem.rendeles_darab}</div>
                    <div className="col-5 text-center">{arFuggveny(elem.rendeles_ar)} Ft</div>
                </div>
            ))}

            <div className="row mt-3">
                <div className="col-7 text-start">
                    <h5>Bruttó ár:</h5>
                </div>
                <div className="col-5 text-center">
                    <h5>{arFuggveny(osszArSzamitas())} Ft</h5>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col text-end">
                    <button className="btn ml-2" onClick={() => onClose(false)}>
                        <IoCloseSharp />Bezárás
                    </button>
                </div>
            </div>
        </div>
    )
}


export default RendelesTermekek